import { QueryKey } from '@tanstack/react-query';

export const joinKeys = (primary: string, ...rest: (object | undefined)[]): QueryKey => {
  if (rest?.length) {
    return [primary, ...rest];
  }

  return [primary];
};
